<template>
    <div>
       <div class="addBG">
		   <div class="cfooterBox">
		   		   <div class="cfootNavBox">
		   			   <div class="cfootNavItem" v-for="(item,index) in cfootList" :key="index">
		   				   <div class="title">{{item.catname}}</div>
		   				   <ul>
		   					   <li v-for="(items,indexs) in item.children" :key="indexs" @click="goUrl(items)">{{items.catname}}</li>
		   				   </ul>
		   			   </div>
								<div v-if="!isEn">
									<div class="phone">{{phone}}</div>
									<div class="phoneText">商务洽谈</div>
								</div>
		   			   <!-- <img src="../img/blueIcon.png" alt="" class="footerLoge">  -->
		   		   </div>
				   <div class="cfootInfo">
					   <span class="footLink"><a href="http://beian.miit.gov.cn/" target="_blank">© 2020 厦门市恒连网络科技有限公司 闽ICP备18016968号 隐私政策</a></span>
						  <!-- 第三方 -->
						 	<div class="thirdParty" v-if="!isEn">
		   			   	<span>关注我们</span>
		   			   	<div class="thirdPartyItem" v-for="(item,index) in thirdPartyList" :key="index" @mousemove="changeData(item,index)" @mouseout="out(item,index)">
									<img class="icon" :src="item.img" alt="">
									<div class="thirdPartyImg" v-if="item.flag">
										<div class="name">{{item.name}}</div>
											<img  :src="item.img_" alt="">
									</div>
								</div>
								<a href="http://www.kuanbaorui.com" class="thirdPartyItem enBox">
									<img class="icon" src="../img/enIcon.png" alt="">
								</a>
		   		    </div>
							 <div class="thirdParty" v-else>
		   			   	<span>Follow Us：</span>
		   			   	<div class="thirdPartyItem" v-for="(item,index) in focusList" :key="index" @click="urlLink(item)">
									<img class="icon" :src="item.img" alt="">
								</div>
		   		    </div>
				   </div>
		   </div>
	   </div>
    </div>
</template>
<style scoped>
	.addBG {width: 100%;background: #FBFBFB; display: flex;justify-content: center;}
	.cfooterBox {min-width: 900px; margin: 0 auto;padding-top: 48px;}
	.thirdParty { display: flex; align-items: center;margin-right: 4.25vw;}
	.thirdParty span{font-size: 16px;font-family: AlibabaPuHuiTi;font-weight: 500;color: #999999;line-height: 42px;}
	.thirdParty .thirdPartyItem {width: 30px; height: 30px;margin-left: 21px;position: relative;cursor: pointer; }
	.enBox{width: 26px!important;height: 26px!important;}
	.thirdParty .thirdPartyItem .icon{width: 100%;height: 100%;}
	.thirdPartyImg {text-align: center; width: 214px;height: 246px;position: absolute; right: -95px; top: -245px; z-index: 9999;background: url('~@/img/erCodeFoot.png') no-repeat;background-size: 100% 100%;}
	.thirdPartyImg .name{font-size: 14px;font-family: Adobe Heiti Std;font-weight: normal;color: #317651;margin-top: 30px;}
	.thirdPartyImg img{display: block; width: 130px;height: 130px;margin: 0 auto;margin-top: 18px;}
	.cfootNavBox {display: flex;min-width: 1200px;}
	.cfootNavItem {color: #666666;margin-right: 120px;}
	.cfootNavItem .title{font-size: 18px;font-family: Microsoft YaHei;font-weight: 400;color: #212121;margin-bottom: 28px;}
	/* .cfootNavItem div{font-size: 16px; margin-bottom: 29px;} */
	.cfootNavItem li{ font-size: 14px; margin-bottom: 17px;cursor:pointer;}
	.footerLoge {width: 161px; height: 49px;margin-left: auto;margin-right: 60px;}
	.cfootInfo{display: flex;justify-content:space-between;margin-top: 60px;margin-bottom: 35px; color: #666666;}
	.cfootInfo a{text-decoration:none;color: #666666;}
	.cfootInfo .footLink{margin-top:14px;}
	.cfootNavItem li:hover{color: #009144;}
	.phone{margin-top:-11px; font-size: 30px;font-family: Arial;font-weight: bold;color: #009144;line-height: 42px;}
	.phoneText{margin-left: 26px;margin-top: 13px; font-size: 24px;font-family: Microsoft YaHei;font-weight: 400;color: #666666;line-height: 42px;}
</style>

<script>
import * as axios from '../../src/axios/api.js'
import imgUrl from '../../src/utils/imgUrl.js'
  export default {
    data() {
      return {
        activeIndex: '1',
				phone:'',
				isEn:false,
				customWxImg:'',
				thirdPartyList:[
					{
						name:'糠宝瑞微信公众号',
						img:require('../img/wx.png'),
						img_:'',
						flag:false
					},
					{
						name:'糠宝瑞微信小程序',
						img:require('../img/xcx.png'),
						img_:'',
						flag:false
					}
				],
				focusList:[
					{
						url:'https://www.facebook.com/Ricerd-104619875514802',
						img:require('../img/en_f_icon.png'),
					},
					{
						url:'https://www.instagram.com/ricerdhusk/',
						img:require('../img/en_in_icon.png'),
					},
					{
						url:'https://twitter.com/Ricerdcom',
						img:require('../img/en_gg_icon.png'),
					},
					{
						url:'https://www.linkedin.com/company/ricerd',
						img:require('../img/en_img_icon.png'),
					},
					{
						url:'https://www.tiktok.com/@ricehusk.dinnerware',
						img:require('../img/en_douyin_icon.png'),
					},
					{
						url:'',
						img:require('../img/en_zn_icon.png'),
					}
				],
				cfootList:[]
      };
    },
	created() {
		this.getQrcode();
	},
    methods: {
			goUrl(item){
				var path=item.url
				var url=''
				if(path.indexOf('http')!= -1){
					window.location.href = path;
				}else{
					if(path.indexOf('?')!=-1){
						url=path+'&id='+item.id
						this.$router.push(url)
					}else{
						url=item.url
						this.$router.push({path: url,query: {id:item.id}});
					}
				}
			},
			getQrcode() {
				axios.post('/api/index/config').then(res => {
						if(res.code==1){
							this.cfootList=res.data.footer
							this.phone =res.data.business_telephone
							this.$set(this.thirdPartyList[0],'img_',imgUrl.imgUrl(res.data.web_site_weixin));
							this.$set(this.thirdPartyList[1],'img_',imgUrl.imgUrl(res.data.web_site_applet));
							this.customWxImg=imgUrl.imgUrl(res.data.web_stie_qrcode);
						}
				});
			},
			// 鼠标悬停
			changeData(e,index){
				if(index == 0 ){
					e.img = require('../img/wx_.png')
				}else{
					e.img = require('../img/xcx_.png')
				}
				e.flag = true
			},
			// 鼠标移出
			out(e,index){
				if(index == 0 ){
					e.img = require('../img/wx.png')
				}else{
					e.img = require('../img/xcx.png')
				}
				e.flag = false
			}
    }
  }
</script>
